// extracted by mini-css-extract-plugin
export default {"actions":"style_actions__6ls2T","title":"style_title__U4C5o"};